const points = [
  {
    path: 'cheques',
    name: 'cheques',
    icon: 'cil-spreadsheet',
    showInMenu: true,
    components: {
      content: () => import('@/views/pages/cheque/New.vue')
    },
    meta: {
      requiredRole: ['admin', 'middleAdmin'],
      moduleSlug: 'points-management'
    }
  },
  {
    path: 'importers',
    name: 'points-importer',
    icon: 'cil-cloud-upload',
    meta: {
      requiredRole: ['admin', 'middleAdmin'],
      moduleSlug: 'points-importer'
    },
    children: [
      {
        path: 'importer-types',
        name: 'points-importer-config-importers',
        icon: 'cil-settings',
        showInMenu: false, // true
        components: {
          content: () => import('@/plugins/points-importer/view/pages/importer-types/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
          moduleSlug: 'points-importer'
        }
      },
      {
        path: 'importer-types/:id',
        name: 'points-importer-config-edit-importer',
        showInMenu: false,
        components: {
          content: () => import('@/plugins/points-importer/view/pages/importer-types/Edit.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
          moduleSlug: 'points-importer'
        }
      },
      {
        path: 'importer-types',
        name: 'points-importer-config-add-importer',
        showInMenu: false,
        components: {
          content: () => import('@/plugins/points-importer/view/pages/importer-types/New.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
          moduleSlug: 'points-importer'
        }
      },
      {
        path: '',
        name: 'points-importer-import',
        icon: 'cil-stream',
        showInMenu: true,
        components: {
          content: () => import('@/plugins/points-importer/view/pages/importer/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
          moduleSlug: 'points-importer'
        }
      },
      {
        path: 'new',
        name: 'points-importer-import-new',
        components: {
          content: () => import('@/plugins/points-importer/view/pages/importer/New.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
          moduleSlug: 'points-importer'
        }
      },
      {
        path: ':id',
        name: 'points-importer-import-show',
        components: {
          content: () => import('@/plugins/points-importer/view/pages/importer/Show.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
          moduleSlug: 'points-importer'
        }
      }
    ]
  },
  {
    path: 'exporters',
    name: 'points_exporter',
    icon: 'cil-cloud-download',
    meta: {
      requiredRole: ['admin', 'middleAdmin'],
      moduleSlug: 'points-exporter'
    },
    children: [
      {
        path: '',
        name: 'points_exporter_export',
        icon: 'cil-download',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/points/Export.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
          moduleSlug: 'points-exporter'
        }
      }
    ]
  },
  {
    path: 'booster',
    name: 'booster',
    icon: 'cil-list-high-priority',
    meta: {
      requiredRole: ['admin', 'middleAdmin'],
      moduleSlug: 'booster'
    },
    children: [
      {
        path: '',
        name: 'booster_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/booster/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
          moduleSlug: 'booster'
        }
      },
      {
        path: 'new',
        showInMenu: true,
        name: 'booster_setup',
        components: {
          content: () => import('@/views/pages/booster/New.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
          moduleSlug: 'booster'
        }
      },
      {
        path: 'preview',
        showInMenu: true,
        name: 'booster_preview',
        components: {
          content: () => import('@/views/pages/booster/Preview.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
          moduleSlug: 'booster'
        }
      },
      {
        path: ':id',
        showInMenu: false,
        name: 'booster_edit',
        components: {
          content: () => import('@/views/pages/booster/Edit.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
          moduleSlug: 'booster'
        }
      }
    ]
  }
]

export default points
